
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  lang: 'no',
  token_client_id: 'MotoGruppenBackEnd',
  token_grant_type: 'password',
  token_client_secret: 'moto@123@',
  PasswordEncryptionKey: 'ABCDEFGHIJ123456',
  commentLength: 1000,
  privacyPolicyLink: 'https://motorgruppen.no/admin/wp-content/uploads/2024/08/Personvernerklaering-Motor-Gruppen.pdf',
  SplitHours: 6

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
